import { render, staticRenderFns } from "./GestorList.vue?vue&type=template&id=c6a4a91c"
import script from "./GestorList.vue?vue&type=script&lang=js"
export * from "./GestorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports